export default __webpack_public_path__ + "static/media/039-crystals.3155f9eb.svg";